"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _fs = _interopRequireDefault(require("fs"));

var _path = _interopRequireDefault(require("path"));

var _uploadOptionsBase = _interopRequireDefault(require("./upload-options-base"));

var _uploadError = _interopRequireDefault(require("./upload-error"));

var _errorCodes = _interopRequireDefault(require("./error-codes"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * Analyzes the given file options and determines if there is sufficient information
 * to upload the file. If insufficient, the method will throw an exception.
 *
 * @param {object} options Information about the file to upload.
 */
function ensureRequiredOptions(options) {
  if (!options.fileName && !options.fileUrl || !options.fileSize && options.fileSize !== 0 || !options.filePath && (!options.blob || !options.blob.slice)) {
    throw new _uploadError.default('UploadFile missing required fields. Must have one of fileName or fileUrl, fileSize, and either filePath or blob', _errorCodes.default.INVALID_OPTIONS);
  }
}
/**
 * Represents a file to upload, as provided in upload options. Includes information like the file's name and size.
 * Also provide capabilities for reading chunks of the file.
 */


var UploadFile = /*#__PURE__*/function (_UploadOptionsBase) {
  _inherits(UploadFile, _UploadOptionsBase);

  var _super = _createSuper(UploadFile);

  /**
   * Constructs a new instance based on the given information.
   *
   * @param {object} options Options as provided when the direct binary upload was instantiated.
   * @param {DirectBinaryUploadOptions} uploadOptions  Options as provided when the upload was initiated.
   * @param {object} fileOptions Options for the specific file, as provided in the upload options.
   * @param {string} fileOptions.fileName The name of the file as it should appear when uploaded.
   * @param {number} fileOptions.fileSize Total size of the file to upload, in bytes.
   * @param {string} [fileOptions.filePath] Full path to the local filesystem file to upload. Either this value or "blob" must be provided.
   * @param {Array} [fileOptions.blob] Full binary content of the file to upload. Either this value or "filePath" must be provided.
   */
  function UploadFile(options, uploadOptions, fileOptions) {
    var _this;

    _classCallCheck(this, UploadFile);

    _this = _super.call(this, options, uploadOptions);
    _this.fileOptions = fileOptions;
    return _this;
  }
  /**
   * Retrieves the full URL of the file, based on the given upload options
   * and file options.
   *
   * @returns {string} URL of the file.
   */


  _createClass(UploadFile, [{
    key: "getFileUrl",
    value: function getFileUrl() {
      ensureRequiredOptions(this.fileOptions);
      var _this$fileOptions = this.fileOptions,
          fileUrl = _this$fileOptions.fileUrl,
          fileName = _this$fileOptions.fileName;

      if (!fileUrl) {
        fileUrl = "".concat(this.getUploadOptions().getUrl(), "/").concat(encodeURIComponent(fileName));
      }

      return fileUrl;
    }
    /**
     * Retrieves the name of the file as provided in the options.
     *
     * @returns {string} Name of the file.
     */

  }, {
    key: "getFileName",
    value: function getFileName() {
      ensureRequiredOptions(this.fileOptions);

      var name = _path.default.basename(new URL(this.getFileUrl()).pathname);

      return decodeURIComponent(name);
    }
    /**
     * Retrieves the size of the file, in bytes, as provided in the options.
     *
     * @returns {number} Size of the file.
     */

  }, {
    key: "getFileSize",
    value: function getFileSize() {
      ensureRequiredOptions(this.fileOptions);
      return this.fileOptions.fileSize;
    }
    /**
     * Retrieves a value indicating whether or not a new version of the file should be
     * created if it already exists.
     *
     * @returns {boolean} True if a new version should be created, false otherwise.
     */

  }, {
    key: "shouldCreateNewVersion",
    value: function shouldCreateNewVersion() {
      ensureRequiredOptions(this.fileOptions);
      return !!this.fileOptions.createVersion;
    }
    /**
     * Retrieves the label of the new version should one need to be created.
     *
     * @returns {string} A version label.
     */

  }, {
    key: "getVersionLabel",
    value: function getVersionLabel() {
      ensureRequiredOptions(this.fileOptions);
      return this.fileOptions.versionLabel;
    }
    /**
     * Retrieves the comment of the new version should one need to be created.
     *
     * @returns {string} A version comment.
     */

  }, {
    key: "getVersionComment",
    value: function getVersionComment() {
      ensureRequiredOptions(this.fileOptions);
      return this.fileOptions.versionComment;
    }
    /**
     * Retrieves a value indicating whether or not the asset should be replaced if
     * it already exists.
     *
     * @returns {boolean} True if the asset should be replaced, false otherwise.
     */

  }, {
    key: "shouldReplace",
    value: function shouldReplace() {
      ensureRequiredOptions(this.fileOptions);
      return !!this.fileOptions.replace;
    }
    /**
     * Retrieves a chunk of the file for processing, based on the start and end
     * offset. The type of value returned by this method will vary depending on
     * the file options that were provided to the constructor.
     * @param {number} start Byte offset, inclusive, within the file where the chunk will begin.
     * @param {number} end Byte offset, exclusive, within the file where the chunk will end.
     * @returns {Readable|Array} If "filePath" was provided in the file options when constructed,
     *  then the return value will be a Readable stream. If "blob" was provided in the file options
     *  then the return value will be an Array.
     */

  }, {
    key: "getFileChunk",
    value: function getFileChunk(start, end) {
      ensureRequiredOptions(this.fileOptions);
      var _this$fileOptions2 = this.fileOptions,
          filePath = _this$fileOptions2.filePath,
          blob = _this$fileOptions2.blob;

      if (filePath) {
        return _fs.default.createReadStream(filePath, {
          start: start,
          end: end
        });
      }

      return blob.slice(start, end);
    }
    /**
     * Retrieves the headers that should be included with each part upload request.
     * @returns {object} Simple object whose names are header names, and whose values
     *  are header values.
     */

  }, {
    key: "getPartHeaders",
    value: function getPartHeaders() {
      ensureRequiredOptions(this.fileOptions);
      var _this$fileOptions$par = this.fileOptions.partHeaders,
          partHeaders = _this$fileOptions$par === void 0 ? {} : _this$fileOptions$par;
      return partHeaders;
    }
    /**
     * Converts the class instance into a simple object representation.
     *
     * @returns {object} Simplified view of the class instance.
     */

  }, {
    key: "toJSON",
    value: function toJSON() {
      var _this$fileOptions3 = this.fileOptions,
          fileSize = _this$fileOptions3.fileSize,
          filePath = _this$fileOptions3.filePath;
      var json = {
        fileUrl: this.getFileUrl(),
        fileSize: fileSize
      };

      if (this.shouldCreateNewVersion()) {
        json.createVersion = true;
      }

      if (this.getVersionComment()) {
        json.versionComment = this.getVersionComment();
      }

      if (this.getVersionLabel()) {
        json.versionLabel = this.getVersionLabel();
      }

      if (this.shouldReplace()) {
        json.replace = this.shouldReplace();
      }

      if (filePath) {
        json.filePath = filePath;
      }

      if (Object.keys(this.getPartHeaders()).length) {
        json.multipartHeaders = this.getPartHeaders();
      }

      return json;
    }
  }]);

  return UploadFile;
}(_uploadOptionsBase.default);

exports.default = UploadFile;